import { authEndpoints } from '@/api/endpoints';
import type { FetcherService } from '@/services/abstract/FetcherService';
import { MlkemKeysService } from '@/services/abstract/poc/MlkemKeysService';
import type { FetchOptions } from '@/types/api.types';

const buildAuthOptions = (token?: string): FetchOptions =>
  token !== undefined && token !== ''
    ? { headers: { Authorization: `Bearer ${token}` } }
    : {};

export class MlkemKeysServiceImpl extends MlkemKeysService {
  constructor(private readonly fetcherService: FetcherService) {
    super();
  }

  public async registerMlkemKeys(
    id: string,
    data: { encapsKey: string; decapsKey: string },
    registrationToken?: string
  ): Promise<void> {
    await this.fetcherService.post(
      authEndpoints.registerMlkemKeys(id),
      data,
      buildAuthOptions(registrationToken)
    );
  }

  public async updateMlkemKeys(
    id: string,
    data: { encapsKey: string; decapsKey: string },
    token?: string
  ): Promise<void> {
    await this.fetcherService.patch(
      authEndpoints.updateMlkemKeys(id),
      data,
      buildAuthOptions(token)
    );
  }
}
